import React, { useEffect, useState } from "react";
import { fetchCategories, updateCategory, toggleCategoryStatus } from "../services/api";

function CategoryEditor() {
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState(null);
  const [editCategory, setEditCategory] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [successPopupVisible, setSuccessPopupVisible] = useState(false); // Success popup state

  useEffect(() => {

    const userRole = sessionStorage.getItem("userRole");
        const userProject = sessionStorage.getItem("project");

        // Pass down project token query parameter if NOT super_admin
        const projectFilter = userRole !== "super_admin" ? userProject : null;
    const fetchCategoriesData = async () => {
      try {
        const response = await fetchCategories(projectFilter);
        const sortedCategories = response.sort((a, b) => a.cat_id - b.cat_id);
        setCategories(sortedCategories);
        setFilteredCategories(sortedCategories);
      } catch (err) {
        setError("Failed to fetch categories");
        console.error(err);
      }
    };
    fetchCategoriesData();
  }, []);

  useEffect(() => {
    if (searchQuery === "") {
      setFilteredCategories(categories);
    } else {
      const filtered = categories.filter((category) =>
        category.cat_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredCategories(filtered);
    }
  }, [searchQuery, categories]);

  const handleEdit = (category) => {
    setEditCategory(category);
    setPopupVisible(true);
  };

  const handlePopupClose = () => {
    setPopupVisible(false);
    setEditCategory(null);
  };

  const handleSave = async () => {
    try {
      if (editCategory) {
        const { cat_id: oldCatId, cat_name: newCatName, description, language, active , project } = editCategory;

        const updatedCategory = await updateCategory(oldCatId, newCatName, description, language, active , project);

        const updatedCategories = categories.map((cat) =>
          cat.cat_id === oldCatId ? { ...cat, ...updatedCategory } : cat
        );

        setCategories(updatedCategories);
        setFilteredCategories(updatedCategories);

        setPopupVisible(false);

        // Show success popup
        setSuccessPopupVisible(true);
        setTimeout(() => setSuccessPopupVisible(false), 3000); // Hide after 3 seconds
      }
    } catch (error) {
      console.error("Failed to update category:", error.message);
      alert("Failed to update the category. Please try again.");
    }
  };

  const handleToggleStatus = async (cat_id, isActive) => {
    try {
      await toggleCategoryStatus(cat_id, !isActive);
      const updatedCategories = categories.map((cat) =>
        cat.cat_id === cat_id ? { ...cat, active: !isActive } : cat
      );
      setCategories(updatedCategories);
      setFilteredCategories(updatedCategories);
    } catch (error) {
      console.error("Failed to toggle category status:", error);
    }
  };
  const languageMapping = {
    en_US: "English",
    hi_IN: "Hindi",
  };


  const projectMapping = {
    jagranquiz: "Jagran",
    joshquiz: "Josh",
  };
  if (error) return <p>{error}</p>;

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Category Manager</h1>

      <div style={styles.searchContainer}>
        <input
          type="text"
          placeholder="Search categories by name"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={styles.searchInput}
        />
      </div>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.tableHeader}>Category ID</th>
            <th style={styles.tableHeader}>Category Name</th>
            <th style={styles.tableHeader}>Description</th>
            <th style={styles.tableHeader}>Language</th>
            <th style={styles.tableHeader}>Project</th>
            <th style={styles.tableHeader}>Is Active</th>
            <th style={styles.tableHeader}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredCategories.map((category) => (
            <tr key={category.cat_id} style={styles.tableRow}>
              <td style={styles.tableCell}>{category.cat_id}</td>
              <td style={styles.tableCell}>
                {category.cat_name}
                {category.parent ? ` (${category.parent.cat_name})` : ""}
              </td>
              <td style={styles.tableCell}>{category.description}</td>
              <td style={styles.tableCell}>
                  {languageMapping[category.language] || category.language}
              </td>


              <td style={styles.tableCell}>
                  {projectMapping[category.project] || category.project}
              </td>

              <td style={styles.tableCell}>
                <span
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: category.active ? "green" : "red",
                    display: "inline-block",
                  }}
                ></span>
              </td>
              <td style={styles.tableCell}>
                <button onClick={() => handleEdit(category)} style={styles.editButton}>
                  Edit
                </button>
                {/* <button
                  onClick={() => handleToggleStatus(category.cat_id, category.active)}
                  style={styles.toggleButton}
                >
                  {category.active ? "Deactivate" : "Activate"}
                </button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {popupVisible && (
        <div style={styles.popup}>
          <div style={styles.popupContent}>
            <h3>Edit Category</h3>
            <label>
              Name:
              <input
                type="text"
                value={editCategory.cat_name}
                onChange={(e) =>
                  setEditCategory({ ...editCategory, cat_name: e.target.value })
                }
                style={styles.input}
              />
            </label>
            <label>
              Description:
              <textarea
                value={editCategory.description}
                onChange={(e) =>
                  setEditCategory({ ...editCategory, description: e.target.value })
                }
                style={styles.textarea}
              />
            </label>
            <label>
              Language:
              <select
                value={editCategory.language}
                onChange={(e) =>
                  setEditCategory({ ...editCategory, language: e.target.value })
                }
                style={styles.select}
              >
                <option value="en_US">English</option>
                <option value="hi_IN">Hindi</option>
              </select>
            </label>



            <label>
              Project:
              <select
                value={editCategory.project}
                onChange={(e) =>
                  setEditCategory({ ...editCategory, project: e.target.value })
                }
                style={styles.select}
              >
                <option value="jagranquiz">Jagran</option>
                <option value="joshquiz">Josh</option>
              </select>
            </label>

            <label>
              Status:
              <div>
                <input
                  type="radio"
                  id="active"
                  name="status"
                  value="active"
                  checked={editCategory.active === true}
                  onChange={() =>
                    setEditCategory({ ...editCategory, active: true })
                  }
                  style={styles.radio}
                />
                <label htmlFor="active">Active</label>
                <input
                  type="radio"
                  id="inactive"
                  name="status"
                  value="inactive"
                  checked={editCategory.active === false}
                  onChange={() =>
                    setEditCategory({ ...editCategory, active: false })
                  }
                  style={styles.radio}
                />
                <label htmlFor="inactive">Inactive</label>
              </div>
            </label>

            <button onClick={handleSave} style={styles.saveButton}>
              Save
            </button>
            <button onClick={handlePopupClose} style={styles.cancelButton}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {successPopupVisible && (
        <div style={styles.successPopup}>
          <p>Category updated successfully!</p>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    padding: "30px",
    maxWidth: "1000px",
    margin: "0 auto", // Center the container
  },
  title: {
    marginBottom: "20px",
    fontSize: "28px",
    color: "#333",
    fontWeight: "600",
    textAlign: "center", // Center the title
  },
  searchContainer: {
    marginBottom: "20px",
    textAlign: "center",
  },
  searchInput: {
    padding: "8px 12px",
    fontSize: "14px",
    width: "200px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    margin: "0 auto",
    display: "block",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "center", // Center the button
    marginBottom: "20px",
  },
  addCategoryButton: {
    display: "inline-block",
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "5px",
    fontWeight: "bold",
    textAlign: "center",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "30px",
    backgroundColor: "#f8f9fa",
    textAlign: "center", // Center all content in table cells
  },
  tableHeader: {
    padding: "12px 15px",
    backgroundColor: "#007bff",
    color: "#fff",
    fontWeight: "bold",
    textAlign: "center", // Center-align the header text
  },
  tableRow: {
    borderBottom: "1px solid #ddd",
  },
  tableCell: {
    padding: "12px 15px", // Add padding for better spacing
    textAlign: "center", // Center the content in td
  },
  popup: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000, // Ensure it appears above all other content
  },
  popupContent: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    width: "400px", // Set a fixed width for the popup
    textAlign: "center", // Center-align content in the popup
  },
  input: {
    display: "block",
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  textarea: {
    display: "block",
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  select: {
    display: "block",
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  saveButton: {
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    fontSize: "14px",
    cursor: "pointer",
    marginRight: "10px",
  },
  cancelButton: {
    padding: "10px 20px",
    backgroundColor: "#dc3545",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    fontSize: "14px",
    cursor: "pointer",
  },
  radio: {
    marginRight: "5px",
  },
  successPopup: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "green",
    color: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    zIndex: 1000,
    textAlign: "center",
  },
};

export default CategoryEditor;
